import {
  Grid,
  Typography,
  Button,
} from "@mui/material";
import { Add} from "@mui/icons-material";
import React from "react";

import Loader from "../../components/Loader";
import useItinerary from "./itinerary-hook";
import ItineraryTable from "../../components/itinerary/ItineraryTable";

export default function Itinerary() {
  const {
    activeList,
    closedList,
    loading,
  } = useItinerary();

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <Grid container alignItems={"center"} spacing={2} mb={2}>
        <Grid item>
          <Typography variant="h4" fontWeight={600}>
          Itinerary Management
          </Typography>
        </Grid>
        <Grid item display={"flex"} alignItems={"stretch"}>
          <Button
            size="large"
            disableElevation={false}
            variant="contained"
            startIcon={<Add />}
            onClick={() => (null)}
            sx={{ mr: 1 }}
          >
            Add Itinerary
          </Button>
        </Grid>
      </Grid>
      {/* <Grid container alignItems={"center"} spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4" fontWeight={600}>
            Active Itinerary
          </Typography>
        </Grid>
      </Grid> */}
      <ItineraryTable itineraryList={activeList} />
      <Grid container alignItems={"center"} spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4" fontWeight={600}>
            Closed Itinerary
          </Typography>
        </Grid>
      </Grid>
      <ItineraryTable itineraryList={closedList} />
    </>
  );
}
